import { SET_DASHBOARD_LOADING, SET_DASHBOARD_LOGS, SET_DASHBOARD_SERVERS, SET_CONS_FILE, SET_EXCHANGE_CONS } from "./types";
import { api } from "../App";
import axios from "axios";



export const getLogsData = () => async (dispatch) => {
  try {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: true });
    const { data } = await api.get('/monitoring_lms_cons/logs');
    dispatch({ type: SET_DASHBOARD_LOGS, payload: data.logs });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: false });
  }
}

export const getServersData = () => async (dispatch) => {
  try {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: true });
    const { data } = await api.get('/monitoring_lms_cons/servers', { params: { limit: 150 } });
    dispatch({ type: SET_DASHBOARD_SERVERS, payload: data.servers });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: false });
  }
}
export const getFileList = () => async (dispatch) => {
  try {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: true });
    const { data } = await api.get('/monitoring_lms_cons/cons_file');
    dispatch({ type: SET_CONS_FILE, payload: data.cons_file });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: false });
  }
}
export const getExchangeCons = () => async (dispatch) => {
  try {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: true });
    const { data } = await axios.get('https://certification.edumil.ru/api/xp_organizations/info');
    dispatch({ type: SET_EXCHANGE_CONS, payload: data });
  } catch (ERR) {
    console.error('Error fetching exchange cons:', ERR);
  } finally {
    dispatch({ type: SET_DASHBOARD_LOADING, payload: false });
  }
}